var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "758 5850.5 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    "data-node-id": "6182:5498",
    d: "M770.5 5850.5C763.607 5850.5 758 5856.11 758 5863C758 5869.89 763.607 5875.5 770.5 5875.5C777.393 5875.5 783 5869.89 783 5863C783 5856.11 777.393 5850.5 770.5 5850.5ZM775.103 5866.13C775.51 5866.54 775.51 5867.2 775.103 5867.6C774.9 5867.81 774.633 5867.91 774.367 5867.91C774.1 5867.91 773.833 5867.81 773.63 5867.6L770.5 5864.47L767.37 5867.6C767.167 5867.81 766.9 5867.91 766.633 5867.91C766.367 5867.91 766.1 5867.81 765.897 5867.6C765.49 5867.2 765.49 5866.54 765.897 5866.13L769.027 5863L765.897 5859.87C765.49 5859.46 765.49 5858.8 765.897 5858.4C766.304 5857.99 766.962 5857.99 767.37 5858.4L770.5 5861.53L773.63 5858.4C774.038 5857.99 774.696 5857.99 775.103 5858.4C775.51 5858.8 775.51 5859.46 775.103 5859.87L771.973 5863L775.103 5866.13Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFileIcon);
export default __webpack_public_path__ + "static/media/deleteFileIcon.e3f9e885ffac739ee2640288f338afd7.svg";
export { ForwardRef as ReactComponent };